import { CircleDashed, CirclePlus, CircleMinus, PencilLine } from 'lucide-react'
import type { ReactNode } from 'react'

import { StatusMessage } from '@krp/ui-kit'

import { CHANGE_LABELS, SUBJECT_LABELS } from '../model/labels'
import type { ChangeType, ShownError, Subject } from '../model/types'
import './sync.css'

const CHANGE_ICONS: Readonly<Record<ChangeType, ReactNode>> = {
  added: <CirclePlus size={14} aria-hidden="true" />,
  changed: <PencilLine size={14} aria-hidden="true" />,
  removed: <CircleMinus size={14} aria-hidden="true" />,
  'only-common': <CircleDashed size={14} aria-hidden="true" />,
}

/** Пометка строки: значок, слово и рамка (CLAUDE.md §7 — не только цвет). У строки поля, штрихкода, цены, фото — ещё чего она касается. */
export function ChangeBadge({ change, subject }: { change: ChangeType; subject: Subject }) {
  return (
    <span className="sync-badge" data-change={change}>
      {CHANGE_ICONS[change]}
      {CHANGE_LABELS[change]}
      {subject !== 'item' && ` · ${SUBJECT_LABELS[subject]}`}
    </span>
  )
}

/**
 * Ошибка целиком: заголовок, текст службы или источника дословно, код и идентификатор запроса, «Скопировать» — для передачи
 * администратору. Таймера нет: ошибка уходит, когда человек повторил действие или закрыл окно.
 */
export function ErrorBlock({ error, action }: { error: ShownError; action?: ReactNode }) {
  const meta = `Код: ${error.code}${error.requestId === null ? '' : ` · запрос ${error.requestId}`}`
  return <StatusMessage kind="error" title={error.title} text={error.message} meta={meta} {...(action !== undefined ? { action } : {})} />
}
